<template>
    <views
        :class="{'show-tabbar': showTabbar}"
        class="main">
        <keep-alive include="Home,Person">
            <router-view></router-view>
        </keep-alive>
        <van-tabbar
            v-if="showTabbar"
            v-model="active"
            inactive-color="#bbb"
            :before-change="bchange"
            route>
            <van-tabbar-item replace to="/home">
                <views>首页</views>
                <template #icon="props">
                    <img :src="props.active ? homeActive : home" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/article">
                <views>知识库</views>
                <template #icon="props">
                    <img :src="props.active ? zskActive : zsk" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace :to="$store.getters.getHasLucky?'/scan-code?type=prize&public=1':''">
                <views>抽奖</views>
                <template #icon="props">
                    <img :src="props.active ? prizeActive : prize" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/person">
                <views>我的</views>
                <template #icon="props">
                    <img :src="props.active ? myActive : my" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </views>
</template>

<script>
import { mapState } from 'vuex'
import tools from '@/mixins/tools'
export default {
    mixins: [tools],
    data() {
        return {
            active: 0,
            home: require('@/assets/images/sy_syg@3x.png'),
            homeActive: require('@/assets/images/sy_syb@3x.png'),
            zskActive: require('@/assets/images/sy_zskb@3x.png'),
            zsk: require('@/assets/images/sy_zskg@3x.png'),
            prizeActive: require('@/assets/images/sy_cjb@3x.png'),
            prize: require('@/assets/images/sy_cjg@3x.png'),
            myActive: require('@/assets/images/sy_wdb@3x.png'),
            my: require('@/assets/images/sy_wdg@3x.png')
        }
    },
    computed: {
        ...mapState({
            showTabbar: state => state.showTabbar
        })
    },
    methods: {
        bchange(index) {
            if (index === 2 && !this.$store.getters.getHasLucky) {
                this.$toast('暂无抽奖活动')
                return false
            }
            return true
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
